import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPagedResponse } from '../../apiInterfaces';
import { ILogisticsSyncChange, ILogisticsSyncChangeFilters } from './';

interface ILogisticsSyncChangesState {
  currentSyncLogChanges: ILogisticsSyncChange[];
  filters: ILogisticsSyncChangeFilters;
  totalFilteredItems: number;
}

const initialState: ILogisticsSyncChangesState = {
  currentSyncLogChanges: [],
  filters: { searchTerm: '', page: 0, take: 15 },
  totalFilteredItems: 0
};

// tslint:disable: no-empty
const logisticsSyncChangesSlice = createSlice({
  initialState,
  name: 'logistics/syncChanges',
  reducers: {
    fetch: () => {},
    set: (state, action: PayloadAction<IPagedResponse<ILogisticsSyncChange>>) => {
      state.currentSyncLogChanges = action.payload.items;
      state.totalFilteredItems = action.payload.totalItems;
    },
    setFilters: (state, action: PayloadAction<ILogisticsSyncChangeFilters>) => {
      state.filters = action.payload;
    }
  }
});

export const {
  actions: logisticsSyncChangesActionCreators,
  reducer: logisticsSyncChangesReducer
} = logisticsSyncChangesSlice;
